import React, { useContext, useEffect, useState } from 'react'
import { NewAddressContextComp } from '../AddressContext/NewAddressContext';
import Note from '../Note/Note';
import AddressChangeBtnNav from '../AddressChangeBtnNav/AddressChangeBtnNav';
import ValidationModal from 'components/ValidationModal';
import { AddressChangeContext } from '../AddressContext/AddressChangeContext';
import CheckboxConfirm from 'components/StraightThroughVehicleComp/2_Confirm/ConfirmBody/CheckboxConfirm';
import QuestionRow from '../CustomInputs/QuestionRow/QuestionRow';
import NewAddressSection from './NewAddressSection';
import { DriverHHMContextComp } from 'components/StraightThroughHouseholdComp/HouseholdContext/DriverHHMContext';
import DriverHHM_ConfirmForm from 'components/StraightThroughHouseholdComp/2_Confirm/DriverHHM_ConfirmForm';
import DriverAssignmentConfirm from 'components/StraightThroughVehicleComp/2_Confirm/ConfirmBody/DriverAssignmentConfirm';
import monthsDOB from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/Months';

export const AddressConfirm_SaveContext = React.createContext();

const ChangeAddressConfirm_Main = () => {
    const context = useContext(AddressChangeContext)
    const [isLargeScreen, setIsLargeScreen] = useState(false);
    const [confirmChanges, setConfirmChanges] = useState(false);

    // Update state based on window size
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setIsLargeScreen(true);
            } else {
                setIsLargeScreen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const saveConfirmCheckbox = (value) => {
        setConfirmChanges(value);

        var classCopy = context["addressChangeClass"];
        classCopy.confirmation = value;
    }

    const displayHouseholdChanges = () => {
        if (context?.addressChangeClass?.driversHHMs?.drivers?.newDrivers?.length > 0)
            return true;
        else if (context?.addressChangeClass?.driversHHMs?.householdMembers?.newMembers?.length > 0)
            return true;
        else if (context?.addressChangeClass?.driversHHMs?.drivers?.storedDrivers?.some(driver => driver.componentTracker && Object.keys(driver.componentTracker).length > 0))
            return true;
        else if (context?.addressChangeClass?.driversHHMs?.householdMembers?.storedMembers?.some(member => member?.componentTracker && member?.componentTracker !== ""))
            return true;
        return false;
    }

    // Helper function to convert month name to month index
    const monthNameToIndex = (monthName) => {
        const months = monthsDOB
        return months.indexOf(monthName);
    };

    // Calculates the age of the driver on changes of the dob fields
    const calculateAge = (dobMonth, dobDay, dobYear) => {
        const today = new Date();
        const birthMonthIndex = monthNameToIndex(dobMonth);
        const birthDate = new Date(dobYear, birthMonthIndex, dobDay);
        let age = today.getFullYear() - dobYear;
        const monthDifference = today.getMonth() - birthDate.getMonth();

        // Adjust age if the birthday hasn't happened yet this year
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < dobDay)) {
            age--;
        }
        return age;
    };

    const displayDriverAssignment = () => {
        var storedMembers = context?.addressChangeClass?.driversHHMs?.householdMembers?.storedMembers?.filter(member => member?.editType !== "");
        // Added driver form completed
        if (context?.addressChangeClass?.driversHHMs?.drivers?.newDrivers?.length > 0) return true;
        // Added household member as a driver
        else if (context?.addressChangeClass?.driversHHMs?.householdMembers?.newMembers?.length > 0 &&
            calculateAge(context?.addressChangeClass?.driversHHMs?.householdMembers?.newMembers[0]?.userInfo?.dobMonth, context?.addressChangeClass?.driversHHMs?.householdMembers?.newMembers[0]?.userInfo?.dobDay, context?.addressChangeClass?.driversHHMs?.householdMembers?.newMembers[0]?.userInfo?.dobYear) >= 16 &&
            context?.addressChangeClass?.driversHHMs?.householdMembers?.newMembers[0]?.driverInfo?.ownInsurance === "0")
            return true;
        // Updated household member "As a Driver"
        else if (storedMembers?.some((member) => member?.componentTracker === "Update HHM" && member?.editType === "Add as driver on policy.")) return true;
        else return false;
    }

    return (
        <>
            <h5 className='text-primary text-center fw-bold mb-4'>CHANGE ADDRESS</h5>

            <DriverHHMContextComp>
                {/* Address */}
                <NewAddressSection
                    context={context}
                />

                {/* Changes of Drivers/Household Member Section */}
                {displayHouseholdChanges() &&
                    <>
                        <hr />
                        <DriverHHM_ConfirmForm
                            context={context}
                            isLargeScreen={isLargeScreen}
                        />
                    </>
                }

                {/* Driver Assignment */}
                {displayDriverAssignment() &&
                    <>
                        <hr className='less-margin' />
                        <div className='mx-0 mx-sm-5'>
                            <div className='mx-sm-3'>
                                <DriverAssignmentConfirm
                                    vehReqContext={AddressChangeContext}
                                    reqVehicleClass={"addressChangeClass"}
                                />
                            </div>
                        </div>
                        <hr className='less-margin' />
                    </>
                }

                <AddressConfirm_SaveContext.Provider
                    value={{
                        saveConfirmCheckbox,
                        confirmChanges
                    }}
                >
                    <CheckboxConfirm styles={styles} requestType={"Address"} />
                </AddressConfirm_SaveContext.Provider>

                <hr />
                <Note />
                <hr />

                <AddressChangeBtnNav />

            </DriverHHMContextComp>

            <ValidationModal
                title={context.validationTitle}
                show={context.showModal}
                handleClose={() => context.setShowModal(false)}
                validationMsg={context.validationMsg}
            />
        </>
    )
}

const styles = {
    checkboxContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingRight: '0'
    }
}

export default ChangeAddressConfirm_Main